<script setup lang="ts">
import { DispatchTemplate } from "@/types/entity";
import { useRouter } from "vue-router";

defineProps<{
  templateList: DispatchTemplate[];
}>();

const router = useRouter();

const handleTemplateClick = (template: DispatchTemplate) => {
  router.push({
    name: "worldMissionEdit",
    query: { uuid: template.uuid },
  });
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-for="template in templateList"
      :key="template.id"
      class="flex flex-col gap-2 border p-3 rounded cursor-pointer bg-base-100 hover:bg-base-200 transition-colors"
      @click="handleTemplateClick(template)"
    >
      <div class="font-bold text-sm line-clamp-2">
        {{ template.name }}
      </div>
      <div
        class="text-xs text-base-content/70 line-clamp-3"
        v-html="template.description"
      ></div>
    </div>
  </div>
</template>
